import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";
import { UtilTraits } from "traits/util-traits";
import { CodePlaygroundContainer } from "components/code-playground/code-playground-container";

import HeroTmpl from "./templates/landing-templates/landing-hero.tmpl.html";
import CoreTmpl from "./templates/landing-templates/landing-core.tmpl.html";
import VBLPatternTmpl from "./templates/landing-templates/landing-vbl.tmpl.html";
import PluginsTmpl from "./templates/landing-templates/landing-plugins.tmpl.html";
import ShellTmpl from "./templates/landing-templates/landing-shell.tmpl.html";
import CloserTmpl from "./templates/landing-templates/landing-closing-cta.tmpl.html";

// Sections holding a `npx spyne-cli create-app` command bar (hero, closer)
// broadcast the snippet click and copy the command themselves.
class LandingCliSection extends ViewStream {
  constructor(props = {}) {
    props.channels = ["CHANNEL_UI"];
    super(props);
  }

  broadcastEvents() {
    return [[".cli-snippet", "click"]];
  }

  addActionListeners() {
    return [["CHANNEL_UI_CLICK_EVENT", "onCliSnippetClick", ".cli-snippet"]];
  }

  onCliSnippetClick() {
    const snippetEl$ = this.props.el$(".cli-snippet");
    UtilTraits.util$CopyToClipboard(snippetEl$.el.querySelector("code").innerText);
    snippetEl$.addClass("copied");
    window.setTimeout(() => snippetEl$.removeClass("copied"), 1200);
  }
}

export class PageHome extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.pageData);
    props.id = "l1-home";
    props.class = "app-page";
    props.data["heroContent"] = props.appData.homePageHeroContent;
    props.template = require("./templates/page-home.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    const containsLinks = this.props.el$("a").exists;
    const broadcastEls = containsLinks ? ["a", "click"] : [];
    return [broadcastEls];
  }

  onRendered() {
    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();

    this.page$ScrollToTopOnLoad();

    // Ratified zoom order: Hero → THE CORE → THE PATTERN → THE PLUGINS → Application Shell → Closer
    this.appendView(new LandingCliSection({ template: HeroTmpl }), "#page-header");
    this.appendView(new ViewStream({ template: CoreTmpl }), "#page-body");
    this.appendView(new ViewStream({ template: VBLPatternTmpl }), "#page-body");
    this.appendView(new ViewStream({ template: ShellTmpl }), "#page-body");
    this.appendView(new ViewStream({ template: PluginsTmpl }), "#page-body");
    this.appendView(new LandingCliSection({ template: CloserTmpl }), "#page-body");
    this.appendView(new CodePlaygroundContainer({ codeBlockId: "home" }), ".code-container-holder");
  }
}
